module.exports = __webpack_public_path__ + "img/iconControlValveProduct.45643195.svg";